import { isRecord } from '../Markdown/widgets/answerWidgetPayload.ts';
import { type Message, MessageRole } from './types.ts';

export type AnswerWidgets = Record<string, unknown>;

const ANSWER_WIDGET_PROVIDER = 'openx';

/**
 * Groups widget payloads by the invocation that produced them, keyed by widget id.
 *
 * A widget can arrive on a different event than its answer, before or after it, so it is matched on
 * `invocation_id` and never on message order. Only `openx` widgets are kept: `mcp` is reserved by
 * ADK for MCP Apps, which this chat does not host.
 */
export function collectAnswerWidgets(messages: Message[]): Map<string, AnswerWidgets> {
  const byInvocation = new Map<string, AnswerWidgets>();

  for (const message of messages) {
    if (message.role !== MessageRole.WIDGET || !message.invocation_id || !isRecord(message.widget)) continue;

    const { id, provider, payload } = message.widget;
    if (provider !== ANSWER_WIDGET_PROVIDER || typeof id !== 'string' || id.length === 0) continue;

    const widgets = byInvocation.get(message.invocation_id) ?? {};
    widgets[id] = payload ?? null;
    byInvocation.set(message.invocation_id, widgets);
  }

  return byInvocation;
}
